import React from "react";
import { useIsMobile } from "./useIsMobile";

/**
 * Encabezado de página DS:
 *   - eyebrow uppercase (fecha o sección)
 *   - title display (Nohemi)
 *   - description opcional
 *   - actions a la derecha (botones)
 *
 * En mobile (<768px) el título baja a 22px, las acciones colapsan
 * en línea propia debajo y se distribuyen full-width — los Button
 * dentro de `actions` ocupan su tamaño natural; si necesitas que se
 * estiren añade `style={{ flex: 1 }}` desde el caller.
 */
export function PageHeader({ eyebrow, title, description, actions, style }) {
  const isMobile = useIsMobile();
  return (
    <div
      style={{
        display: "flex",
        flexDirection: isMobile ? "column" : "row",
        alignItems: isMobile ? "stretch" : "flex-end",
        justifyContent: "space-between",
        gap: isMobile ? 12 : 16,
        flexWrap: "wrap",
        ...(style || {}),
      }}
    >
      <div style={{ minWidth: 0, flex: 1 }}>
        {eyebrow && (
          <div
            style={{
              fontSize: 11,
              letterSpacing: "0.04em",
              textTransform: "uppercase",
              color: "var(--kr-fg-muted)",
              fontWeight: 600,
              marginBottom: 4,
            }}
          >
            {eyebrow}
          </div>
        )}
        {title && (
          <h1
            className="kr-display"
            style={{
              margin: 0,
              fontSize: isMobile ? 22 : 28,
              fontWeight: 700,
              letterSpacing: "-0.02em",
              color: "var(--kr-fg-strong)",
              lineHeight: 1.15,
            }}
          >
            {title}
          </h1>
        )}
        {description && (
          <p
            style={{
              margin: "6px 0 0",
              fontSize: 14,
              color: "var(--kr-fg-muted)",
              maxWidth: isMobile ? "none" : 720,
            }}
          >
            {description}
          </p>
        )}
      </div>
      {actions && (
        <div
          style={{
            display: "flex",
            gap: 8,
            flexShrink: 0,
            flexWrap: "wrap",
            // En mobile las acciones quedan en su propia fila tras el
            // bloque de texto, alineadas a la izquierda para seguir el
            // ritmo de lectura.
            justifyContent: isMobile ? "flex-start" : "flex-end",
          }}
        >
          {actions}
        </div>
      )}
    </div>
  );
}

export default PageHeader;
